<template>
  <div class="a-rms-day-pickup-tooltip">
    <v-tooltip
      content-class="tooltip-shadow pickup-tooltip-content"
      color="white"
      :open-delay="400"
      :close-delay="0"
      transition="none"
      right
    >
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" x-small class="cursor-pointer">
          mdi-information-slab-circle-outline
        </v-icon>
      </template>
      <span class="text-center justify-center align-center pickup-tooltip">
        <v-data-table
          :headers="headers"
          :items="items"
          :item-class="getDatatableRowClass"
          sort-by="rn"
          sort-desc="true"
          hide-default-footer
          disable-pagination
          dense
        >
          <template v-slot:[`item.intermediate_name`]="{ item }">
            <span class="text-caption">{{ item.intermediate_name }}</span>
          </template>
          <template v-slot:[`item.rn`]="{ item }">
            <span class="text-caption">{{ item.rn }}</span>
          </template>
          <template v-slot:[`item.room_revenue`]="{ item }">
            <span class="text-caption font-weight-bold">
              {{ item.room_revenue }}
              <span class="currency-symbol font-weight-bold">€</span>
            </span>
          </template>
        </v-data-table>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "a-rms-day-pickup-tooltip",
  props: {
    date: {
      type: String,
      required: true
    },
    spot: {
      type: Number,
      required: true
    }
  },
  computed: {
    headers() {
      return [
        {
          align: "start",
          sortable: true,
          value: "intermediate_name",
          text: `${this.$t("pickup_" + this.spot).toUpperCase()} | ${this.date}`
        },
        {
          text: this.$t("rn_dense"),
          align: "center",
          sortable: true,
          value: "rn"
        },
        {
          text: this.$t("room_revenue_dense"),
          align: "center",
          sortable: true,
          value: "room_revenue"
        }
      ];
    },
    items() {
      return this.all_kpis_daily_pickup && this.all_kpis_daily_pickup[this.date]
        ? this.all_kpis_daily_pickup[this.date][this.spot]
        : [];
    },
    ...mapState({
      all_kpis_daily_pickup: state => state.rms.all_kpis_daily_pickup
    })
  },
  methods: {
    getDatatableRowClass(item) {
      let classes = "a-datatable-row";
      return classes;
    }
  }
};
</script>

<style lang="scss">
.pickup-tooltip-content {
  .v-data-table {
    .v-data-table__wrapper {
      overflow: hidden;
      th {
        padding: 0 !important;
        font-size: 10px !important;
        .v-icon {
          font-size: 12px !important;
        }
      }
      .a-datatable-row {
        td {
          padding: 0 4px !important;
          height: auto !important;
          width: auto !important;
          .currency-symbol {
            margin-left: -3px;
            font-size: 10px !important;
          }
          .v-btn--fab.v-size--x-small {
            height: 15px;
            width: 15px;
          }
        }
      }
    }
  }
}
</style>
